export default __webpack_public_path__ + "static/media/POS1.36d0bda0.png";